import { FormattedMessage } from "react-intl";

const InjectMassage = ({ id, ...props }) => (
  <FormattedMessage id={id} {...props} />
);

export default InjectMassage;
